/**
 * Stripe Configuration
 * 
 * Imports keys from stripe-keys.js file.
 * For setup: Copy stripe-keys.example.js to stripe-keys.js and fill in your keys.
 */

import STRIPE_KEYS from './stripe-keys.js';
import * as tierService from '../services/tierService';

export const STRIPE_CONFIG = {
  // Product IDs from stripe-keys.js (legacy - kept for backward compatibility)
  PRODUCTS: {
    MONTHLY: STRIPE_KEYS.PRODUCTS.MONTHLY,
    YEARLY: STRIPE_KEYS.PRODUCTS.YEARLY,
  },
  
  // Publishable key from stripe-keys.js
  PUBLISHABLE_KEY: STRIPE_KEYS.PUBLISHABLE_KEY,
  
  // Helper function to check if a product ID matches monthly or yearly (legacy)
  isMonthlyProduct: (productId) => {
    return productId === STRIPE_CONFIG.PRODUCTS.MONTHLY;
  },
  
  isYearlyProduct: (productId) => {
    return productId === STRIPE_CONFIG.PRODUCTS.YEARLY;
  },
  
  // Get tier from priceId
  getTierFromPriceId: (priceId) => {
    return tierService.getTierFromPriceId(priceId);
  },
  
  // Get priceIds for a tier (both monthly and yearly)
  getPriceIdsForTier: (tierId) => {
    return tierService.getPriceIdsForTier(tierId);
  },
};

export default STRIPE_CONFIG;

